import { FC, SVGProps } from 'react';

const SearchIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="square"
      />
      <path d="M13.3894 13.9238L17.0322 17.7085" stroke={color} stroke-width="1.5" stroke-linecap="round" />
    </svg>
  );
};

export default SearchIcon;
